import * as React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/styles/app.scss";
import { Preference } from "./setup/preference";

// Visual Refresh must be set before the first render; Cloudscape reads it once per page load.
try {
    const savedPreference: { labs?: unknown } | null = JSON.parse(localStorage.getItem(Preference.KEY) || "null");
    const savedLabs = savedPreference?.labs;
    if (Array.isArray(savedLabs) && savedLabs.includes(Preference.Lab.AgenticUI)) {
        document.body.classList.add("awsui-visual-refresh");
        document.documentElement.classList.add("pf-agentic-ui");
    }
} catch (e: unknown) {
    console.warn("Failed to read lab preference", e);
}

const container = document.getElementById("ask-legal-ui");
const root = createRoot(container);
root.render(<App />);